import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/RealtimeListener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/context/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/index.css");
